import React, { Component, useEffect, useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { transLabel } from '../translations/util';
import { useCookies } from 'react-cookie';
import Message from "../Components/message";
import { loginUser, loginUserSuccess } from '../Redux/actions/userActions';
import {
  Input,
  DatePicker,
} from 'rsuite';
import Select from 'react-select';
import { Form, Schema } from 'rsuite';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const { ArrayType, StringType, DateType, NumberType, ObjectType } = Schema.Types;

const TextField = React.forwardRef((props, ref) => {
  const { name, label, accepter, ...rest } = props;
  return (
    <Form.Group controlId={`${name}-4`} ref={ref}>
      <Form.ControlLabel style={{ color: "white" }}>{label} </Form.ControlLabel>
      <Form.Control name={name} accepter={accepter} {...rest} />
    </Form.Group>
  );
});

const Login = () => {
  const translations = useSelector(state => state.translationReducer);
  const [translation, setTranslation] = useState([]);
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies(['languaje']);
  const formRef = React.useRef();
  const [formError, setFormError] = React.useState({});
  const msgRef = React.useRef();
  const [formValue, setFormValue] = React.useState({});
  let lan = (cookies.languaje == null) ? "ES" : cookies.languaje;
  let requieredText = (lan == "ES") ? ". Requerido" : ". Required";
  const dispatch = useDispatch();
  const [casos, setCasos] = useState([]);
  const toPage = (page) => {
    navigate(page)
  }

  const [Locality, setLocality] = useState([]);
  const [esAnonimo, setAnonymousLogin] = useState(false);
  const [model, setModel] = useState();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    toPage("/consulta");
  };

  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    async function loadModel() {
      let model = Schema.Model({
        usuario: StringType().isEmail(transLabel("NewCase.validEmail")).isRequired(transLabel("NewCase.eMail") + requieredText),
        password: StringType().isRequired(transLabel("NewCase.password") + requieredText)
      });

      setModel(model);
    }

    loadModel();
  }, []);

  useEffect(() => {
    setTranslation(translations.data);
  }, [translations]);

  /*let model = Schema.Model({
    usuario: StringType().isEmail(transLabel("NewCase.validEmail")).isRequired(transLabel("NewCase.eMail") + requieredText),
    password: StringType().isRequired(transLabel("NewCase.password") + requieredText)
  });*/

  const handleAnonyousLoginChange = (e) => {
    if (esAnonimo == true) {
      let model = Schema.Model({
        usuario: StringType().isEmail(transLabel("NewCase.validEmail")).isRequired(transLabel("NewCase.eMail") + requieredText),
        password: StringType().isRequired(transLabel("NewCase.password") + requieredText)
      });

      setAnonymousLogin(false);
      setModel(model);
    }
    else {
      let model = Schema.Model({
        password: StringType().isRequired(transLabel("NewCase.password") + requieredText)
      });

      setModel(model);
      setAnonymousLogin(true);
    }
  }

  const hanledCaseChange = async (e) => {
    dispatch(loginUserSuccess(e));
  }

  const handleSubmit = () => {
    console.log("login");
    if (!formRef.current.check()) {
      let msg = "";

      for (const [key, value] of Object.entries(formError)) {
        msg += value + "<br/>"
      }

      if (msg != "") {
        msgRef.current.show(msg, "Login", 'error');
      }

      return;
    }

    //console.log('FormValue', formValue);

    //console.log("json", formValue);
    dispatch(loginUser(formValue, function (response) {
      if (response != null) {
        if (response.length > 1) {
          setCasos(response);
          setOpen(true);
        }
        else {
          dispatch(loginUserSuccess(response[0]));
          toPage("/consulta");
        }
      }
      else {
        msgRef.current.show("Usuario o clave incorrecto", "Login", 'error');
      }
    }));
  };

  const { t } = useTranslation();

  return (
    <>
      <Header />

      {/* ======= Login ======= */}
      <Form model={model}
        ref={formRef}
        onChange={setFormValue}
        onCheck={setFormError}
        formValue={formValue}
      >
        <div className="container-fluid min-vh-100" style={{ backgroundImage: 'url(assets/img/degradado.png)', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
          <div className="container">
            <div className="row justify-content-md-center">
              <div id="login-access" className="col-lg-6 align-self-center pt-5 px-2 my-5" data-aos="fade-up">
                <div className="float-start-50 px-5">
                  <h2 className="text-light" style={{ fontWeight: 600 }}>{transLabel("Login.title")}</h2>
                  <div className="form-check form-switch text-light my-3">
                    <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onClick={handleAnonyousLoginChange} />
                    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Identificarme como usuario anónimo</label>
                  </div>
                  <br />
                  <div className="mb-3">
                    {
                      esAnonimo == true ?
                        <TextField
                          name="usuario"
                          label={transLabel("Login.code")}
                          error={formError.usuario}
                        />
                        :
                        <TextField
                          name="usuario"
                          label={transLabel("Login.user")}
                          error={formError.usuario}
                        />
                    }
                  </div>
                  <div className="mb-3">
                    <TextField
                      name="password"
                      label={transLabel("Login.password")}
                      error={formError.password}
                      type="password"
                      autoComplete="off"
                    />
                  </div>
                  <div className="d-grid">
                    <button type="button" onClick={handleSubmit} className="btn btn-lg btn-primary my-5">{transLabel("Login.btnAcceder")}</button>
                  </div>
                  <div style={{ textAlign: 'center' }} data-aos="fade-up" data-aos-delay={200}>
                    <img src="assets/img/capital-letter-ethics-channel-ayesa.png" width={180} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>{/* End Login */}
      </Form>
      <Footer />
      <Dialog
        disableEnforceFocus={true}
        PaperProps={{ style: { overflow: 'visible' } }} open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{transLabel("Login.modalTitle")}</DialogTitle>
        <DialogContent style={{ overflow: 'visible', width: "400px" }}>
          <DialogContentText>
            <Select
              className="basic-single"
              isSearchable={true}
              placeholder={transLabel("Login.selMensaje")}
              options={casos}
              onChange={hanledCaseChange}
              getOptionLabel={option => option['titulo']}
              getOptionValue={option => option['idCaso']}
              menuShouldScrollIntoView={false}
              maxMenuHeight="200px"
            />
          </DialogContentText>
          <DialogActions>
            <button type="button" onClick={handleClose} className="btn btn-primary">{transLabel("Login.btnAceptar")}</button>
            <button type="button" onClick={handleCancel} className="btn btn-default">{transLabel("Login.btnCancel")}</button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Message ref={msgRef}></Message>
    </>
  );
}

export default Login;